import { getDefaultHeader } from './serviceAPIHelper';
export const fullSearch = async function (value, endpoint = 'fullsearch', originCode='') {
    let formattedSuggestions = [];
    let token = localStorage.getItem('token');
    if (token == null) {
        return;
    }

    function Capitalizmo(string) {
        return string.length >= 2 ?
            string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : string;
    }

    function validateAndCase(text) {
        let haspoint = (text || '').match(/(([^\s.]+){2}|\s+?)/gi);
        if (haspoint) {
            haspoint.map(k => {
                text = text.replace(k, Capitalizmo(k));
            });
            return text;
        }
        return (text || '');
    }

    function getTitleFromTypeName(type) {
        if (type.toLowerCase() === 'town') {
            return 'HOME.FTS_SECTION_TITLE_CITIES';
        }
        else {
            if (type === 'MTP') {
                return 'HOME.FTS_SECTION_TITLE_MEETING_POINTS';
            } else{
                return 'HOME.FTS_SECTION_TITLE_ZONES';
            }
        }
    }

    function formatSuggestions(data) {

        let formattedSuggestions = data.map(d => {

            const normalizedCountry = validateAndCase(d.country);
            const normalizedProvince = validateAndCase(d.province);
            const normalizedCity = validateAndCase(d.city);
            const normalizedName = validateAndCase(d.name);

            let locationMessage = [];
            if (normalizedName !== '') {
                locationMessage.push(normalizedName);
            }
            if (normalizedCity !== '') {
                locationMessage.push(normalizedCity);
            }
            if (normalizedProvince !== '') {
                locationMessage.push(normalizedProvince);
            }
            if (normalizedCountry !== '') {
                locationMessage.push(normalizedCountry);
            }
            let title = '';
            if (d.type) {
                title = getTitleFromTypeName(d.type.name);
            } else {
                title = 'HOME.FTS_SECTION_TITLE_HOTELS';
            }
            locationMessage = locationMessage.join(', ');

            return Object.assign({}, d, {
                'title': title,
                'formattedName': locationMessage
            });
        });

        return formattedSuggestions;
    }

    let response = await fetch(
        process.env.REACT_APP_API_URL + `${endpoint}?text=${value}` + `&zoneCode=${originCode}`,
        {
            method: 'GET',
            headers: getDefaultHeader(true)
        });

    let data = await response.json();
    if (Array.isArray(data)) {
        formattedSuggestions = formatSuggestions(data);
    } else {
        let cities = data.cities ? formatSuggestions(data.cities) : [];
        let hotels = data.hotels ? formatSuggestions(data.hotels) : [];
        let zones = data.zones ? formatSuggestions(data.zones) : [];
        formattedSuggestions = cities.concat(hotels.concat(zones));
    }

    let result = formattedSuggestions.reduce((acc, cur) => {
        let aux = acc.find(a => a.title === cur.title);
        aux.data.push(cur);
        return acc;

    }, [
        { 'title': 'HOME.FTS_SECTION_TITLE_ZONES', 'data': [] },
        { 'title': 'HOME.FTS_SECTION_TITLE_MEETING_POINTS', 'data': [] },
        { 'title': 'HOME.FTS_SECTION_TITLE_CITIES', 'data': [] },
        { 'title': 'HOME.FTS_SECTION_TITLE_HOTELS', 'data': [] }]
    );

    result = result.filter(r => r.data.length);
    return result;
};


// WEBPACK FOOTER //
// ./src/services/fullsearch.js